import * as actions from './timer.actions'

const initialState = {}

const actionsMap = {
  // Delay the end of the timer
  [actions.DELAY]: (state, action) => {
    const { id, ticks } = action.data

    return {
      ...state,
      [id]: {
        ...state[id],
        remaining: state[id].remaining + ticks,
      },
    }
  },

  // Advance the end of the timer
  [actions.ADVANCE]: (state, action) => {
    const { id, ticks } = action.data

    return {
      timers: {
        ...state,
        [id]: {
          ...state[id],
          remaining: state[id].remaining - ticks,
        },
      },
    }
  },

  // Perform tick transfromation on every registered timer
  [actions.TICK]: (state) => {
    const timers = { ...state }
    for (let timerId in timers) {
      const { remaining, running } = timers[timerId]

      if (running) {
        if (remaining > 0) {
          timers[timerId].remaining -= 1
        } else {
          delete timers[timerId] // Destroy the timer one tick after reach zero
        }
      }
    }

    return timers
  },

  // Set timer expiration
  [actions.SET_EXPIRATION]: (state, action) => {
    const { id, ticks } = action.data

    return {
      ...state,
      [id]: {
        ...state[id],
        remaining: ticks,
      },
    }
  },

  // Start the countdown.
  [actions.START]: (state, action) => {
    const id = action.data

    return {
      ...state,
      [id]: {
        ...state[id],
        running: true,
      },
    }
  },
  [actions.STOP]: (state, action) => {
    const id = action.data

    return {
      ...state,
      [id]: {
        ...state[id],
        running: false,
      },
    }
  },
}

/* eslint require-jsdoc: 0 */
export function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
